import React from "react";
import Helmet from "react-helmet";
import Meta from "../components/Meta";
import Icon from "../components/Icon";
import Block from "../components/Blocks";
import { BackBannerBlockNews } from "../components/Banners";
import { formatDate } from "../util/helperFunctions";
import graphql from "../util/graphql";

// This template: All News articles
class Story extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const links = [].slice.call(
      document.querySelectorAll(".text-block__container a")
    );
    links.map(l => l.setAttribute("target", "_blank"));
  }

  render() {
    const { data } = this.props;
    const page = data.mortyStory;
    const blocks = page.childrenMortyBlock.map(b => {
      return <Block key={b.id} block={b} />;
    });

    return (
      <div className="news-story mb3 mb4-l">
        <Meta page={page} />
        <BackBannerBlockNews page={page} />
        <div className="w-calc-64 mw-696 center">
          <div className="flex jusitfy-start items-center pv2">
            <Icon path="icon-18-news" width="16" height="17" className="mr1" />
            <h4 className="h-4 ttu">
              {page.publishedDate && formatDate(page.publishedDate)}
            </h4>
          </div>
          {blocks}
        </div>
      </div>
    );
  }
}

export default Story;

export const pageQuery = graphql`
  query Story($id: String!) {
    mortyStory(id: { eq: $id }) {
      title
      route
      subtitle
      publishedDate
      abstract
      metaTitle
      metaDescription
      metaKeywords
      abstractPhotoAltText
      abstractPhotoFocalPointX
      abstractPhotoFocalPointY
      abstractPhoto {
        url
      }
      childrenMortyBlock {
        id
        blockType
        content
        headline
        subheadline
        buttonUrl
        buttonTitle
        format
        caption
        subcaption
        url
        attribution
        focalPointX
        focalPointY
        altText
        attributionAltText
        attributionPhoto {
          url
        }
        image {
          url
        }
        videoType
        videoMinutes
        embedCode
        attribution
        attributionAltText
        attributionPhoto {
          url
        }
        vistityTitle
        vistityUrl
      }
    }
  }
`;

export const previewQuery = `
  query Story($id: String!) {
    mortyStory(id: { eq: $id }) {
      title
      route
      subtitle
      publishedDate
      abstract
      metaTitle
      metaDescription
      metaKeywords
      abstractPhotoAltText
      abstractPhotoFocalPointX
      abstractPhotoFocalPointY
      abstractPhoto {
        url
      }
      childrenMortyBlock {
        id
        blockType
        content
        headline
        subheadline
        buttonUrl
        buttonTitle
        format
        caption
        subcaption
        url
        attribution
        focalPointX
        focalPointY
        altText
        attributionAltText
        attributionPhoto {
          url
        }
        image {
          url
        }
        videoType
        videoMinutes
        embedCode
        attribution
        attributionAltText
        attributionPhoto {
          url
        }
        vistityUrl
        vistityTitle
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/Story.js